import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BlazeAI = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M10.5433 12.8279C10.5615 12.8279 10.5814 12.8279 10.603 12.828C11.1326 12.8297 12.6502 12.8347 13.8003 11.9571C14.6337 11.321 15.1381 10.3231 15.1381 9.22655C15.1381 8.45894 15.0394 7.94354 14.617 7.34041C14.617 7.34041 15.5 6.56183 15.5 5.23093C15.5 3.72168 14.756 2.50779 13.0209 2.1157C12.5108 2.00043 11.2668 2 11.2668 2L7.14997 2.00087L3.15522 6.42553L1.50001 12.828L4.69362 12.8268L10.5433 12.8279Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.69362 12.8268L10.5433 12.8279C10.5615 12.8279 10.5814 12.8279 10.603 12.828C11.1326 12.8297 12.6502 12.8347 13.8003 11.9571C14.6337 11.321 15.1381 10.3231 15.1381 9.22655C15.1381 8.45894 15.0394 7.94354 14.617 7.34041C14.617 7.34041 15.5 6.56183 15.5 5.23093C15.5 3.72168 14.756 2.50779 13.0209 2.1157C12.5108 2.00043 11.2668 2 11.2668 2L7.14997 2.00087L3.15522 6.42553L1.50001 12.828L4.69362 12.8268Z"
        fill={color}
      />
      <path
        d="M11.2668 2L11.2669 1.82L11.2668 1.82L7.14993 1.82087L7.06996 1.82089L7.01637 1.88025L3.02162 6.30491L2.99201 6.3377L2.98095 6.38048L1.32574 12.783L1.26754 13.0081L1.50008 13.008L4.69359 13.0068H4.6937L10.5433 13.0079H10.5433L10.6024 13.008L10.6096 13.008C11.1423 13.0098 12.7107 13.015 13.9095 12.1002C14.7876 11.43 15.3181 10.3791 15.3181 9.22655C15.3181 8.48824 15.2281 7.95446 14.8487 7.36271C14.8616 7.34876 14.8754 7.33355 14.8899 7.31708C14.9784 7.21682 15.0954 7.06953 15.2121 6.87866C15.4455 6.49697 15.68 5.93741 15.68 5.23093C15.68 4.44725 15.4867 3.72605 15.0555 3.14689C14.6231 2.56611 13.9633 2.14411 13.0606 1.94012C12.7869 1.87827 12.332 1.84919 11.9595 1.83476C11.7703 1.82743 11.5974 1.82374 11.4718 1.82189C11.409 1.82096 11.3579 1.82049 11.3225 1.82025L11.2815 1.82003L11.2707 1.82001L11.2679 1.82L11.2672 1.82L11.267 1.82L11.2669 1.82L11.2668 2Z"
        stroke="#4C566A"
        strokeWidth="0.36"
      />
      <path
        d="M5.58986 12.0094L7.6953 2.71924H11.8799C12.2088 2.71924 12.9194 2.77187 13.3668 2.98241C14.2353 3.39034 14.538 4.21934 14.538 4.91676C14.538 5.39048 14.4064 5.8642 14.1169 6.2458C13.6695 6.85111 13.0905 6.99586 12.6299 7.11429C13.3537 7.44326 14.209 7.82486 14.209 9.20654C14.209 9.96975 13.8537 10.6935 13.301 11.1935C12.4852 11.9304 11.3535 12.0094 10.7613 12.0094H5.58986ZM9.57704 4.40357L9.11647 6.37739H10.8403C11.314 6.35107 12.2746 6.3116 12.2746 5.24573C12.2746 4.4562 11.6035 4.41673 11.2482 4.40357H9.57704ZM8.73486 8.06172L8.23482 10.2987H10.2481C10.7482 10.2856 11.2219 10.2724 11.564 9.81184C11.7483 9.56183 11.8009 9.25917 11.8009 9.02231C11.8009 8.86441 11.7746 8.71966 11.722 8.58807C11.4851 8.1012 11.0377 8.08804 10.6692 8.06172H8.73486Z"
        fill="white"
      />
    </svg>
  )
})

export default BlazeAI
